import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import './styles.scss';

import StyledLink from '../../StyledLink';

const AddressInfo = props => {
  if (props.address && props.branch) {
    return (
      <>
        <li className="company-widget-info address">
          {props.t('companyInfo.hqAddress')}: {props.address}
        </li>
        <li className="company-widget-info branch">
          {props.t('companyInfo.branchAddress')}: {props.branch}
        </li>
      </>
    );
  }
  if (props.address) {
    return (
      <li className="company-widget-info address">
        {props.t('companyInfo.companyAddress')}: {props.address}
      </li>
    );
  }
  return <></>;
};

const CompanyDetailsWidget = ({
  uid,
  description,
  address,
  branch,
  phone,
  url,
  disclaimer,
  notApprovedMessage,
  notApprovedLink,
}) => {
  const { t } = useTranslation('account');

  return (
    <div>
      <div className="company-widget-info-list">
        <AddressInfo branch={branch} address={address} t={t} />
        <li className="company-widget-info phone">{phone}</li>
        <li className="company-widget-info website">
          <StyledLink href={url} target="_blank" rel="noopener noreferrer">
            {url}
          </StyledLink>
        </li>
        <p className="company-widget-description">{description}</p>
        <li className="company-widget-info disclaimer" style={disclaimer != null ? {} : { display: 'none' }}>
          <StyledLink href={'https://moneyhouse.ch/company/' + uid} target="_blank" rel="noopener noreferrer">
            {t('companyInfo.disclaimer')}
          </StyledLink>
        </li>

        <p className="company-widget-not-approved-message">{notApprovedMessage}</p>
        <Link className="company-widget-not-approved-link" to="/">
          {notApprovedLink}
        </Link>
      </div>
    </div>
  );
};

export default CompanyDetailsWidget;
